import { Elements } from "@stripe/react-stripe-js";
import { useSyncExternalStore, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { DevErrorDisplay } from "../../../components/core/blocks/DevErrorDisplay";
import { getStripeLoad, subscribeToStripe } from "../../../utils/stripe";

function StripeLoadFailure({ error }: { error: unknown }) {
  const { t } = useTranslation(["admin"]);
  return (
    <DevErrorDisplay
      error={error}
      userMessage={t(
        ($) =>
          $.admin[
            "The payment form could not be loaded. An ad blocker or network restriction may be blocking Stripe — turn it off for this site and reload the page to try again."
          ],
      )}
    />
  );
}

export function StripeElements({ children }: { children: ReactNode }) {
  const load = useSyncExternalStore(subscribeToStripe, getStripeLoad);

  if (load.status === "failed") {
    return <StripeLoadFailure error={load.error} />;
  }

  return <Elements stripe={load.status === "ready" ? load.stripe : null}>{children}</Elements>;
}
